import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './HeroSection.css';
import HerosecImg from '../assets/imgs/sav.png'
import '../App.css'
import {Link} from "react-router-dom";

const HeroSection = () => {
    return (
        <Container className="hero-section">
            <Row>
                <Col lg={6} md={12} sm={12} className="hero-text">
                    <h2 className="hero-text-h1">Hi!</h2>
                    <h3 className="hero-text-h3 mt-4">I am ANAM, a Professional Graphic Designer.</h3>
                    <p className="hero-text-p mt-4">
                        who is passionate about Logo Branding Design and Website Design! I have a team of
                        expert Graphic Designers and Website Developers, we are expert in logo, branding, All types of
                        banners, packing, stationary, social media and website designs etc. Provide quality work and
                        Customer satisfaction is our primary goal. So Award your Project to Us With 100% Confidence.
                    </p>
                    <div className="hero-button-center mt-4">

                        <Button variant="success" className="meet-team-button">
                            <Link to="/team"  className="link-text">Meet My Team</Link>
                        </Button>
                    </div>
                </Col>
                <Col lg={6} md={12} sm={12} className="hero-section-img">
                    <img src={HerosecImg} className="hero-image d-flex justify-content-start align-items-left" alt="Hero" />

                </Col>
            </Row>
        </Container>
    );
};

export default HeroSection;
